import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { format } from 'date-fns';
import { FaArrowRight } from 'react-icons/fa';
import { isBreakpointMobile, useBreakpoint } from '../breakpoint';
export const BookingDates = (props) => {
    const { start, end, isStartHalfDay, isEndHalfDay } = props;
    const breakpoint = useBreakpoint();
    const isMobile = isBreakpointMobile(breakpoint);
    const startString = format(new Date(start), isMobile ? 'dd MMM yyyy' : 'dd MMMM yyyy');
    const endString = format(new Date(end), isMobile ? 'dd MMM yyyy' : 'dd MMMM yyyy');
    const isSingleDay = startString === endString;
    const amOnly = '(AM only)';
    const pmOnly = '(PM only)';
    if (isSingleDay) {
        let suffix;
        if (isStartHalfDay) {
            suffix = pmOnly;
        }
        else if (isEndHalfDay) {
            suffix = amOnly;
        }
        else {
            suffix = '';
        }
        return (_jsxs("span", { children: [startString, " ", suffix] }));
    }
    return (_jsxs(Box, { display: 'flex', gap: 1, alignItems: 'center', children: [_jsxs("span", { children: [startString, " ", isStartHalfDay ? pmOnly : ''] }), _jsx(FaArrowRight, {}), _jsxs("span", { children: [endString, " ", isEndHalfDay ? amOnly : ''] })] }));
};
